import { render } from "./LikertChart.vue?vue&type=template&id=92b6e624"
import script from "./LikertChart.vue?vue&type=script&lang=js"
export * from "./LikertChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/walleka/projektit/2022-02-aluevaalit-vaalikonevastaukset/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__